import { MessageFormatElement } from 'intl-messageformat-parser';

const messages: Record<string, string> | Record<string, MessageFormatElement[]> = {
    closePage: "Fermer la page",
    successStatus: "Le paiement a réussi",
    successStatusInfo: "Merci. Vous n'avez plus rien à faire et vous pouvez fermer la page.",
    failedStatus: "Le paiement a échoué.",
    failedStatusInfo: "Et maintenant? Vous pouvez toujours réessayer le lien de paiement dans notre courrier. Vous pouvez également essayer un autre mode de paiement.",
    pendingStatus: "Paiement en attente...",
    pendingStatusInfo: "Veuillez ne pas fermer cette page ni actualiser, vous serez renvoyé sous peu.",
}

export default messages;